import { connect } from 'react-redux'
import * as actions from './actions'
import { createConference } from '../../routes/Room/actions'
import { upgradeUser } from '../../routes/Settings/actions'
import Layout from './Layout'

const mapStateToProps = (state, ownProps) => {
  return {
    isCheckingUser: state.loginLayout.isCheckingUser,
    user: state.loginLayout.user,
    userExists: state.loginLayout.userExists,
    hasErrored: state.loginLayout.hasErrored,
    redirectToLogin: state.loginLayout.redirectToLogin,
    tokenVerified: state.loginLayout.tokenVerified,
    accountType: state.loginLayout.profile.accountType,
    isLoggedIn: state.login.isLoggedIn,
    open: state.loginLayout.open
  }
}

const mapDispatchToProps = dispatch => ({
  returnUserIfUserExists: token =>
    dispatch(actions.returnUserIfUserExists(token)),
  checkValidity: token => dispatch(actions.checkValidity(token)),
  checkTokenOnPathChange: token =>
    dispatch(actions.checkTokenOnPathChange(token)),
  receiveUserdata: user => dispatch(actions.receiveUserdata(user)),
  setUserValidity: bool => dispatch(actions.setUserValidity(bool)),
  shouldRedirectUserToLogin: bool =>
    dispatch(actions.shouldRedirectUserToLogin(bool)),
  createConference: (token, name, recordFlag, MobileFlag) =>
    dispatch(createConference(token, name, recordFlag, MobileFlag)),
  newSeminarUpgradeModal: bool =>
    dispatch(actions.newSeminarUpgradeModal(bool)),
  upgradeUser: (token, userid, plan) =>
    dispatch(upgradeUser(token, userid, plan))
})

const LoginLayoutContainer = connect(mapStateToProps, mapDispatchToProps)(
  Layout
)

export default LoginLayoutContainer



// WEBPACK FOOTER //
// ./src/layouts/LoggedIn/LoginLayoutContainer.js